// extracted by css-extract-rspack-plugin
export default {"PersonInfoForm-person-details":"sputnik__PersonInfoForm-person-details__NvGGM","personInfoFormPersonDetails":"sputnik__PersonInfoForm-person-details__NvGGM"};